export enum ChatSocketChannel {
	CHAT_CHANNEL = 'ChatChannel',
	PING_CHANNEL = 'PingChannel',
}
export const defaultChatChannels = [ChatSocketChannel.PING_CHANNEL]
